import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useCallback, useEffect, useRef, useState } from "react";
import { validateImageFile } from "../components/utils/imageValidation";
import { resizeImage } from "../components/utils/resizeImage";
import { cropImageFile } from "../components/utils/cropImage";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import {
  checkSlugExists,
  getLeagueBySlug,
  updateLeagueBasicInfo,
  updateLeagueFundsDistribution,
  updateLeagueProgressStep,
} from "../components/leagueLocker/firestoreQuery";
import { uploadImage } from "../services/firebase";
import Cropper from "react-easy-crop";
import { Icons } from "../constants/leagueLockerConfig";
import MarkDownWithOption from "../components/ui/MarkDownWithOption";
import {
  ArrowBack,
  IconFacebook,
  IconInstagram,
  IconTiktok,
  IconX,
  IconYoutube,
} from "../components/CustomIcons";
import { Link } from "react-router-dom";

const EditLeaguePage = () => {
  const [leagueName, setLeagueName] = useState("");
  const [leagueUrl, setLeagueUrl] = useState("");
  const [leagueSize, setLeagueSize] = useState("8");
  const [platform, setPlatform] = useState<string | null>(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [leagueId, setLeagueId] = useState<string | null>(null); //Edit mode
  const { leagueSlug } = useParams(); //Edit mode
  const [leagueFunds, setLeagueFunds] = useState<any>(null); //Edit mode
  const [teamJoined, setTeamJoined] = useState(0); // Edit mode
  const [existingBannerImage, setExistingBannerImage] = useState<string | null>(
    null
  );

  const [leagueImage, setLeagueImage] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null); // existingImageUrl from leagueData if present
  const [showCropper, setShowCropper] = useState(false);
  const [tempImageUrl, setTempImageUrl] = useState<string | null>(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState<any>(null);
  const [loadingCropper, setLoadingCropper] = useState(false);
  const leagueImageRef = useRef<HTMLInputElement | null>(null);
  const [isPublic, setIsPublic] = useState(false);

  const [errors, setErrors] = useState<{
    leagueName?: string;
    leagueUrl?: string;
    leagueSize?: string;
    platform?: string;
    leagueBio?: string;
  }>({});

  const [tiktokValue, setTiktokValue] = useState("");

  const [youTubeValue, setYouTubeValue] = useState("");

  const [facebookValue, setFacebookValue] = useState("");

  const [instagramValue, setInstagramValue] = useState("");

  const [xValue, setxValue] = useState("");

  const [detailsValue, setDetailsValue] = useState<string>("");
  const [leagueBio, setleagueBio] = useState<string | null>(null);

  const [socialErrors, setSocialErrors] = useState<{
    tiktok?: string;
    youtube?: string;
    facebook?: string;
    instagram?: string;
    x?: string;
  }>({});

  const { user } = useAuth();
  const navigate = useNavigate();

  const handleImageChange = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) return;
      const validationError = validateImageFile(file);
      if (validationError) {
        alert(`${validationError}`);
        return;
      }
      setLoadingCropper(true);
      try {
        const { resizedUrl } = await resizeImage(file);
        setTempImageUrl(resizedUrl);
        setShowCropper(true);
      } finally {
        setLoadingCropper(false);
      }
    },
    []
  );

  const onCropComplete = useCallback((_: any, croppedPixels: any) => {
    setCroppedArea(croppedPixels);
  }, []);

  const handleCropConfirm = useCallback(async () => {
    if (!tempImageUrl || !croppedArea) return;
    const cropped = await cropImageFile(tempImageUrl, croppedArea);
    if (cropped) {
      setLeagueImage(cropped);
      setImagePreview(URL.createObjectURL(cropped));
    }
    setShowCropper(false);
  }, [tempImageUrl, croppedArea]);

  const handleRemoveImage = () => {
    setLeagueImage(null);
    setImagePreview(null);
    if (leagueImageRef.current) leagueImageRef.current.value = "";
  };

  useEffect(() => {
    const fetchLeagueDetails = async () => {
      if (leagueSlug) {
        try {
          const res = await getLeagueBySlug(leagueSlug);
          console.log("Fetched league data:", res);
          if (res) {
            if (res.createdBy !== user?.uid) {
              navigate("/dashboard");
              return;
            } else {
              setLeagueName(res.leagueName || "");
              setLeagueUrl(res.leagueUrl || "");
              setLeagueSize(res.leagueSize);
              setPlatform(res.platform);
              setLeagueId(res.id || null);
              setLeagueFunds(res.leagueFunds || null);
              setTeamJoined(res.teams ? res.teams.length : 0);
              setImagePreview(res.bannerImage || null);
              setExistingBannerImage(res.bannerImage || null);
              setIsPublic(res.isPublic || false);
              setTiktokValue(res.tiktok);
              setYouTubeValue(res.youtube);
              setFacebookValue(res.facebook);
              setInstagramValue(res.instagram);
              setxValue(res.x);
              setleagueBio(res.leagueBio || null);
              setDetailsValue(res.description ?? "");
            }
          } else {
            navigate("/dashboard");
          }
        } catch (error) {
          console.error("Error fetching league:", error);
          //setErrorText(error as string);
        }
      }
      //setIsLoading(false);
    };
    fetchLeagueDetails();
  }, [leagueSlug]);

  const SOCIAL_PATTERNS: Record<string, RegExp> = {
    tiktok: /^https?:\/\/(www\.)?tiktok\.com\/@[\w.-]+$/i,
    youtube: /^https?:\/\/(www\.)?youtube\.com\/@[\w.-]+$/i,
    facebook: /^https?:\/\/(www\.)?facebook\.com\/[\w.-]+$/i,
    instagram: /^https?:\/\/(www\.)?instagram\.com\/[\w.-]+$/i,
    x: /^https?:\/\/(www\.)?x\.com\/[\w.-]+$/i,
  };

  const formatSocialLink = (
    platform: "tiktok" | "youtube" | "facebook" | "instagram" | "x",
    value: string
  ): string | null => {
    if (!value) return ""; // optional → empty is valid

    let url = value.trim();

    // If not a full URL, treat as handle
    if (!/^https?:\/\//i.test(url)) {
      switch (platform) {
        case "tiktok":
          url = `https://www.tiktok.com/@${url}`;
          break;
        case "youtube":
          url = `https://www.youtube.com/@${url}`;
          break;
        case "facebook":
          url = `https://www.facebook.com/${url}`;
          break;
        case "instagram":
          url = `https://www.instagram.com/${url}`;
          break;
        case "x":
          url = `https://x.com/${url}`;
          break;
      }
    }

    // Validate
    return SOCIAL_PATTERNS[platform].test(url) ? url : null;
  };

  // Auto slug generator (for leagueName → leagueUrl)
  const generateSlug = (title: string) => {
    let slug = "";
    if (title) {
      slug = title
        .normalize("NFD") // split accents
        .replace(/[\u0300-\u036f]/g, "") // remove accent marks
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-") // non-alphanumerics → hyphen
        .replace(/^-+|-+$/g, ""); // trim leading/trailing hyphen
    }
    return slug;
  };

  const handleLeagueNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLeagueName(value);
    setLeagueUrl(generateSlug(value)); // auto slug from title
    setErrors((prev) => ({ ...prev, leagueName: "" }));
  };

  // Allow manual edits to slug, but clean input
  const handleLeagueUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, "") // allow only lowercase letters, numbers, dash
      .replace(/-+/g, "-"); // collapse multiple dashes into one

    console.log("League URL Changed:", value);
    setLeagueUrl(value);
    setErrors((prev) => ({ ...prev, leagueUrl: "" }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmit(true);
    let formErrors: typeof errors = {};

    if (!leagueName.trim()) {
      formErrors.leagueName = "League Name is required";
    }

    if (!leagueUrl.trim()) {
      formErrors.leagueUrl = "League URL is required";
    } else if (leagueUrl.endsWith("-")) {
      formErrors.leagueUrl = "League URL cannot end with a hyphen (-)";
    }
    if (Object.keys(formErrors).length > 0) {
      console.log("Validation Failed:", formErrors);
      setErrors(formErrors);
      return;
    }

    // Validate leagueBio length server-side as well
    if (leagueBio && leagueBio.length > 100) {
      formErrors.leagueBio = "League Bio cannot exceed 100 characters";
      setErrors(formErrors);
      setIsSubmit(false);
      return;
    }

    // Format and validate social links
    const formattedTiktok = tiktokValue
      ? formatSocialLink("tiktok", tiktokValue)
      : null;
    const formattedYoutube = youTubeValue
      ? formatSocialLink("youtube", youTubeValue)
      : null;
    const formattedFacebook = facebookValue
      ? formatSocialLink("facebook", facebookValue)
      : null;
    const formattedInstagram = instagramValue
      ? formatSocialLink("instagram", instagramValue)
      : null;
    const formattedX = xValue ? formatSocialLink("x", xValue) : null;

    const newSocialErrors: typeof socialErrors = {};
    if (tiktokValue && !formattedTiktok)
      newSocialErrors.tiktok = "Please enter a valid TikTok URL or handle";
    if (youTubeValue && !formattedYoutube)
      newSocialErrors.youtube = "Please enter a valid YouTube URL or handle";
    if (facebookValue && !formattedFacebook)
      newSocialErrors.facebook = "Please enter a valid Facebook URL or handle";
    if (instagramValue && !formattedInstagram)
      newSocialErrors.instagram =
        "Please enter a valid Instagram URL or handle";
    if (xValue && !formattedX)
      newSocialErrors.x = "Please enter a valid X URL or handle";

    if (Object.keys(newSocialErrors).length > 0) {
      setSocialErrors(newSocialErrors);
      setIsSubmit(false);
      return;
    }

    let finalSlug = leagueUrl;
    let leagueData = {
      leagueName,
      leagueUrl: finalSlug,
      leagueSize,
      platform,
      leagueBio: leagueBio ?? null,
      tiktok: formattedTiktok,
      youtube: formattedYoutube,
      facebook: formattedFacebook,
      instagram: formattedInstagram,
      x: formattedX,
      description: detailsValue ?? null,
      createdBy: user?.uid ?? "",
      createdAt: new Date().toISOString(),
      isPublic,
    };

    if (!leagueSlug && !leagueId) {
      // only check for new leagues
      while (await checkSlugExists(finalSlug)) {
        const match = finalSlug.match(/^(.*?)(?:-(\d+))?$/);
        if (match) {
          const base = match[1];
          const num = match[2] ? parseInt(match[2], 10) : 0;
          finalSlug = `${base}-${num + 1}`;
        }
      }
      setLeagueUrl(finalSlug);
    } else {
      if (finalSlug !== leagueSlug) {
        // slug changed, need to check
        let slugExists = await checkSlugExists(finalSlug);
        if (slugExists) {
          formErrors.leagueUrl =
            "League slug already exists. Please enter another.";
          setErrors(formErrors);
          setIsSubmit(false);
          return;
        }
        setLeagueUrl(finalSlug);
      }
    }

    if (leagueSlug && leagueId) {
      // update existing league - to be implemented
      let bannerImageUrl =
        existingBannerImage && imagePreview ? existingBannerImage : "";
      if (leagueImage) {
        try {
          bannerImageUrl = await uploadImage(leagueImage);
        } catch (error) {
          console.error("Error uploading image:", error);
        }
      }

      await updateLeagueBasicInfo(leagueId, {
        leagueName: leagueData.leagueName,
        leagueUrl: leagueData.leagueUrl,
        bannerImage: imagePreview ? bannerImageUrl : null,
        isPublic:
          parseInt(leagueData.leagueSize) > teamJoined ? false : isPublic,
        leagueBio: leagueData.leagueBio,
        tiktok: leagueData.tiktok,
        youtube: leagueData.youtube,
        facebook: leagueData.facebook,
        instagram: leagueData.instagram,
        x: leagueData.x,
        description: leagueData.description,
      });
      await updateLeagueProgressStep(leagueId, "add-league-details");
      setIsSubmit(false);
      navigate(`/manage-league/${leagueSlug}`);
    }
  };

  /**
   * On Edit if leagueSize changes, recalculate league funds
   * @param size League Size
   * @returns Calculated league funds based on size (entry fee, total pot, etc
   */
  const calculateLeageueFunds = (size: string) => {
    let distribution = leagueFunds.distribution ? leagueFunds.distribution : [];
    const entryFee = leagueFunds.entryFee || 0;
    let totalPot = parseInt(size) * entryFee;

    let newDistribution = distribution.map((d: any) => ({
      place: d.place,
      percentage: d.percentage,
      amount: (totalPot * d.percentage) / 100,
    }));
    return { totalPot, distribution: newDistribution };
  };

  const isFormValid =
    leagueName.trim() !== "" &&
    leagueUrl.trim() !== "" &&
    Object.values(errors).every((err) => !err);

  return (
    <div className="pageOuterWrapper">
      <Navbar />
      <div className="contentArea otherContentArea">
        <div className="wrapper">
          <div className="backWrap">
            <Link to={`/manage-league/${leagueSlug}`}>
              <ArrowBack /> Back
            </Link>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="yourLeagueHeader">
              <div className="headingItem">League Details</div>
              <div className="actionItems">
                <button
                  type="submit"
                  className="btnStyle btnFilled"
                  disabled={!isFormValid || isSubmit}
                >
                  SAVE
                </button>
              </div>
            </div>
            {showCropper && tempImageUrl && (
              <div className="popupWrapper fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
                <div className="relative w-[90vw] max-w-2xl h-[90vh] bg-white rounded-lg overflow-hidden shadow-lg">
                  <Cropper
                    image={tempImageUrl}
                    crop={crop}
                    zoom={zoom}
                    aspect={16 / 9}
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={onCropComplete}
                  />
                  <div className="absolute bottom-0 left-0 w-full flex justify-between p-4 bg-white border-t">
                    <button
                      type="button"
                      onClick={() => setShowCropper(false)}
                      className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handleCropConfirm}
                      className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                    >
                      Crop & Save
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div className="shadowBlk">
              <div className="blkHeading">📸 League Banner</div>
              <div className="uploadArea">
                {!imagePreview && (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      ref={leagueImageRef}
                      onChange={handleImageChange}
                    />
                    <button
                      className="btnStyle btnHighlighted"
                      type="button"
                      onClick={() => leagueImageRef.current?.click()}
                    >
                      UPLOAD LEAGUE BANNER
                    </button>
                  </>
                )}

                {imagePreview && (
                  <div className="mt-2 relative inline-block">
                    <img
                      src={imagePreview}
                      alt="Punishment Preview"
                      style={{ maxWidth: 300, borderRadius: 8 }}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        handleRemoveImage();
                      }}
                      className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-red-600"
                      style={{ lineHeight: 1, fontSize: 16 }}
                      aria-label="Remove image"
                    >
                      ×
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="shadowBlk">
              <div className="blkHeading">✏️ Edit League Details</div>
              <div className="formGroup">
                <label htmlFor="leagueName">
                  League Name <span className="reqTxt">Required</span>
                </label>
                <input
                  type="text"
                  id="leagueName"
                  placeholder="Enter your league name"
                  value={leagueName}
                  onChange={handleLeagueNameChange}
                  maxLength={100}
                />
                {errors.leagueName && (
                  <div className="errorText">{errors.leagueName}</div>
                )}
              </div>
              <div className="formGroup">
                <label htmlFor="leagueSlug">
                  League Slug <span className="reqTxt">Required</span>
                </label>
                <input
                  type="text"
                  id="leagueSlug"
                  className={errors.leagueUrl ? "fldError" : ""}
                  placeholder="Enter your league slug"
                  value={leagueUrl}
                  onChange={handleLeagueUrlChange}
                />
                {errors.leagueUrl && (
                  <div className="errorText">{errors.leagueUrl}</div>
                )}
              </div>
              <div className="formGroup">
                <label htmlFor="leagueBio">League Bio</label>
                <input
                  type="text"
                  id="leagueBio"
                  placeholder="Enter your league bio"
                  value={leagueBio ?? ""}
                  maxLength={100}
                  onChange={(e) => {
                    const val = e.target.value;
                    // enforce max length (input already has maxLength) and clear error when typing
                    if (val.length <= 100) {
                      setleagueBio(val);
                      setErrors((prev) => ({ ...prev, leagueBio: "" }));
                    }
                  }}
                />
                <div className="text-sm text-gray-500 mt-1">
                  {(leagueBio ?? "").length}/100
                </div>
                {errors.leagueBio && (
                  <div className="errorText">{errors.leagueBio}</div>
                )}
              </div>
              <div className="visibilityWrap">
                <div
                  className={`switchWrap ${
                    teamJoined !== parseInt(leagueSize) ? "switchDisabled" : ""
                  }`}
                >
                  <label>Make Public League?</label>
                  <label className="switchOption">
                    <input
                      type="checkbox"
                      checked={isPublic}
                      onChange={(e) => setIsPublic(e.target.checked)}
                    />
                    <span
                      className={`customCheck ${isPublic ? "haveChecked" : ""}`}
                    >
                      <span
                        className="checkCircle"
                        style={{
                          transform: isPublic
                            ? "translateX(26px)"
                            : "translateX(0)",
                        }}
                      />
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div className="shadowBlk">
              <div className="blkHeading">About This League</div>
              <div className="formGroup">
                <label htmlFor="leagueName">League Description</label>
                <MarkDownWithOption
                  value={detailsValue}
                  onChange={(value) => {
                    setDetailsValue(value ?? "");
                  }}
                />
              </div>
              <div className="leagueBottom">
                <div className="bottomItem">
                  <label htmlFor="">League Size</label>
                  <span className="itemTxt">{leagueSize} Teams</span>
                </div>
                <div className="bottomItem">
                  <label htmlFor="">Hosted On</label>
                  {platform && platform !== "Not Listed" ? (
                    <span className="itemTxt">
                      {Icons[platform as keyof typeof Icons]}
                    </span>
                  ) : (
                    <span className="itemTxt">Not Listed</span>
                  )}
                </div>
              </div>
            </div>
            <div className="shadowBlk">
              <div className="blkHeading">😎 League Social Media</div>
              <div className="socialEditWrap">
                <div className="formGroup">
                  <div className="fldHavePrefix">
                    <span className="fldPrefix">
                      <IconTiktok />
                    </span>
                    <input
                      type="text"
                      placeholder="johndoe"
                      className="fldStyle"
                      value={tiktokValue}
                      onChange={(e) => {
                        setTiktokValue(e.target.value);
                        if (socialErrors.tiktok) {
                          // clear the facebook error as soon as the user types
                          setSocialErrors((prev) => ({ ...prev, tiktok: "" }));
                        }
                      }}
                    />
                  </div>
                  {socialErrors.tiktok && (
                    <span className="errorText">{socialErrors.tiktok}</span>
                  )}
                </div>
                <div className="formGroup">
                  <div className="fldHavePrefix">
                    <span className="fldPrefix">
                      <IconYoutube />
                    </span>
                    <input
                      type="text"
                      placeholder="johndoe"
                      className="fldStyle"
                      value={youTubeValue}
                      onChange={(e) => {
                        setYouTubeValue(e.target.value);
                        if (socialErrors.youtube) {
                          // clear the facebook error as soon as the user types
                          setSocialErrors((prev) => ({ ...prev, youtube: "" }));
                        }
                      }}
                    />
                  </div>
                  {socialErrors.youtube && (
                    <span className="errorText">{socialErrors.youtube}</span>
                  )}
                </div>
                <div className="formGroup">
                  <div className="fldHavePrefix">
                    <span className="fldPrefix">
                      <IconFacebook />
                    </span>
                    <input
                      type="text"
                      placeholder="johndoe"
                      className="fldStyle"
                      value={facebookValue}
                      onChange={(e) => {
                        setFacebookValue(e.target.value);
                        if (socialErrors.facebook) {
                          // clear the facebook error as soon as the user types
                          setSocialErrors((prev) => ({
                            ...prev,
                            facebook: "",
                          }));
                        }
                      }}
                    />
                  </div>
                  {socialErrors.facebook && (
                    <span className="errorText">{socialErrors.facebook}</span>
                  )}
                </div>
                <div className="formGroup">
                  <div className="fldHavePrefix">
                    <span className="fldPrefix">
                      <IconInstagram />
                    </span>
                    <input
                      type="text"
                      placeholder="johndoe"
                      className="fldStyle"
                      value={instagramValue}
                      onChange={(e) => {
                        setInstagramValue(e.target.value);
                        if (socialErrors.instagram) {
                          // clear the facebook error as soon as the user types
                          setSocialErrors((prev) => ({
                            ...prev,
                            instagram: "",
                          }));
                        }
                      }}
                    />
                  </div>
                  {socialErrors.instagram && (
                    <span className="errorText">{socialErrors.instagram}</span>
                  )}
                </div>
                <div className="formGroup">
                  <div className="fldHavePrefix">
                    <span className="fldPrefix">
                      <IconX />
                    </span>
                    <input
                      type="text"
                      placeholder="johndoe"
                      className="fldStyle"
                      value={xValue}
                      onChange={(e) => {
                        setxValue(e.target.value);
                        if (socialErrors.x) {
                          // clear the facebook error as soon as the user types
                          setSocialErrors((prev) => ({ ...prev, x: "" }));
                        }
                      }}
                    />
                  </div>
                  {socialErrors.x && (
                    <span className="errorText">{socialErrors.x}</span>
                  )}
                </div>
              </div>
            </div>

            <button
              type="submit"
              className="btnStyle btnFilled btnFull"
              disabled={!isFormValid || isSubmit}
            >
              SAVE
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EditLeaguePage;
